const getDefaultPaymentsState = () => ({
  stripePublicKey: '',
  savedCards: [],
  selectedCard: {},
});

export default {
  state: getDefaultPaymentsState(),
  actions: {
    async MAKE_PAYMENT_REQUEST_PAYMENT(context, payload) {
      const request = {
        url: payload.url,
        parameters: payload.parameters,
      };
      const mutation = 'UPDATE_ORDER_DETAILS';
      const options = {
        request,
        mutation,
        globalLoading: true,
      };

      return await context.dispatch('MAKE_POST_REQUEST', options);
    },

    UPDATE_ORDER_BALANCE(context, payload) {
      context.rootState.bookings.orders[payload.orderId].balance = 0;
    },

    UPDATE_SELECTED_CARD(context, payload) {
      context.commit('SET_SELECTED_CARD', payload);
    },
    async GET_SAVED_CARDS(context, payload) {
      const request = {
        url: '/api/v4/people/person/saved-cards',
      };
      const mutation = 'UPDATE_SAVED_CARDS';

      const options = {
        request,
        mutation,
        globalLoading: true,
      };

      await context.dispatch('MAKE_GET_REQUEST', options);
    },

    async DELETE_SAVED_CARD(context, payload) {
      const request = {
        url: '/api/v4/parent/payments/saved-cards/delete',
        parameters: {
          cardId: payload.cardId,
        },
      };
      const mutation = 'UPDATE_SAVED_CARDS';
      const message = { success: 'Card removed', icon: '👍' };

      const options = {
        request,
        mutation,
        message,
        globalLoading: true,
      };

      await context.dispatch('MAKE_POST_REQUEST', options);
    },

    async ADD_NEW_CARD(context, payload) {
      const request = {
        url: '/api/v4/parent/payments/saved-cards/add',
        parameters: {
          paymentMethod: payload.paymentMethod,
        },
      };
      const mutation = 'ADD_NEW_CARD';
      const message = { success: 'Card added', icon: '💳', info: true };
      const options = {
        request,
        mutation,
        message,
        globalLoading: true,
      };

      return await context.dispatch('MAKE_POST_REQUEST', options);
    },
  },

  mutations: {
    UPDATE_STRIPE_PUBLIC_KEY(state, payload) {
      state.stripePublicKey = payload;
    },

    UPDATE_ORDER_DETAILS(state, payload) {
      // debugger;
    },
    SET_SELECTED_CARD(state, payload) {
      state.selectedCard = payload;
    },

    ADD_NEW_CARD(state, payload) {
      state.savedCards = payload.savedCards;
      state.selectedCard = payload.cardAdded;
    },

    UPDATE_SAVED_CARDS(state, payload) {
      state.savedCards = payload;
    },

    RESET_PAYMENTS_STATE(state) {
      Object.assign(state, getDefaultPaymentsState());
    },
  },

  getters: {
    stripePublicKey(state) {
      return state.stripePublicKey;
    },
    selectedCard(state) {
      return state.selectedCard;
    },
    savedCards(state) {
      return state.savedCards;
    },
  },
};
